import {
  GET_SALES_EVENT_TYPES_REQUESTED,
  GET_SALES_EVENT_TYPES_SUCCEEDED,
  GET_SALES_EVENT_TYPES_FAILED,
  CREATE_SALES_EVENT_TYPE_REQUESTED,
  CREATE_SALES_EVENT_TYPE_SUCCEEDED,
  CREATE_SALES_EVENT_TYPE_FAILED,
  UPDATE_SALES_EVENT_TYPE_REQUESTED,
  UPDATE_SALES_EVENT_TYPE_SUCCEEDED,
  UPDATE_SALES_EVENT_TYPE_FAILED,
  DELETE_SALES_EVENT_TYPE_REQUESTED,
  DELETE_SALES_EVENT_TYPE_SUCCEEDED,
  DELETE_SALES_EVENT_TYPE_FAILED,
} from './constants'
import api from 'utils/api'

export const deleteSalesEventTypeRequested = () => ({
  type: DELETE_SALES_EVENT_TYPE_REQUESTED,
})

export const deleteSalesEventTypeSucceeded = (payload) => ({
  type: DELETE_SALES_EVENT_TYPE_SUCCEEDED,
  payload,
})

export const deleteSalesEventTypeFailed = () => ({
  type: DELETE_SALES_EVENT_TYPE_FAILED,
})

export const updateSalesEventTypeRequested = () => ({
  type: UPDATE_SALES_EVENT_TYPE_REQUESTED,
})

export const updateSalesEventTypeSucceeded = (payload) => ({
  type: UPDATE_SALES_EVENT_TYPE_SUCCEEDED,
  payload,
})

export const updateSalesEventTypeFailed = () => ({
  type: UPDATE_SALES_EVENT_TYPE_FAILED,
})

export const createSalesEventTypeRequested = () => ({
  type: CREATE_SALES_EVENT_TYPE_REQUESTED,
})

export const createSalesEventTypeSucceeded = (payload) => ({
  type: CREATE_SALES_EVENT_TYPE_SUCCEEDED,
  payload,
})

export const createSalesEventTypeFailed = () => ({
  type: CREATE_SALES_EVENT_TYPE_FAILED,
})

export const getSalesEventTypesRequested = () => ({
  type: GET_SALES_EVENT_TYPES_REQUESTED,
})

export const getSalesEventTypesSucceeded = (payload) => ({
  type: GET_SALES_EVENT_TYPES_SUCCEEDED,
  payload,
})

export const getSalesEventTypesFailed = () => ({
  type: GET_SALES_EVENT_TYPES_FAILED,
})

export const loadSalesEventTypes = (venueUuid) => (dispatch) => {
  dispatch(getSalesEventTypesRequested())

  return api
    .fetchSalesEventTypes(venueUuid)
    .then((response) =>
      dispatch(
        getSalesEventTypesSucceeded(response.data.salesEventTypes)
      )
    )
    .catch(() => dispatch(getSalesEventTypesFailed()))
}

export const createSalesEventType = (data) => (dispatch) => {
  dispatch(createSalesEventTypeRequested())

  return api
    .createSalesEventType(data)
    .then((response) =>
      dispatch(
        createSalesEventTypeSucceeded(response.data.salesEventTypes)
      )
    )
    .catch(() => dispatch(createSalesEventTypeFailed()))
}

export const updateSalesEventType = (data) => (dispatch) => {
  dispatch(updateSalesEventTypeRequested())

  return api
    .updateSalesEventType(data)
    .then((response) =>
      dispatch(
        updateSalesEventTypeSucceeded(response.data.salesEventTypes)
      )
    )
    .catch(() => dispatch(updateSalesEventTypeFailed()))
}

export const deleteSalesEventType = (data) => (dispatch) => {
  dispatch(deleteSalesEventTypeRequested())

  return api
    .deleteSalesEventType(data)
    .then((response) =>
      dispatch(
        deleteSalesEventTypeSucceeded(response.data.salesEventTypes)
      )
    )
    .catch(() => dispatch(deleteSalesEventTypeFailed()))
}
